<div class="">
  <div class="p-0 user-device-admin">

    @if (displayEnabledDevices) {
      <div>
        <h3>{{ 'content.enabled-devices' | translate }}:</h3>
        <div class="d-flex flex-column mb-3 inline-vertical-gap-10">
          @for (device of mfaUserDetails?.userDetails?.devicesDetails || []; track device) {
            <app-mfa-enabled-device
              [device]="device" [userName]="userName" [allowChangingPrimary]="allowChangingPrimary" [allowRemovingDevice]="allowRemovingDevice"
              [numMfaDevice]="mfaUserDetails?.userDetails?.devicesDetails?.length"
            (removed)="devicesChanged()" (updatedPrimary)="devicesChanged()"></app-mfa-enabled-device>
          }
          @if (!mfaUserDetails?.userDetails?.devicesDetails || mfaUserDetails?.userDetails?.devicesDetails?.length === 0) {
            <div>
              {{ 'content.no-devices-enabled' | translate }}
            </div>
          }
        </div>
      </div>
    }

    @if (showAddDevice) {
      <div>
        <h3>{{ 'content.add-a-device' | translate }}</h3>
        <app-add-mfa-device class="pt-2" [userName]="userName" (added)="devicesChanged()"></app-add-mfa-device>
      </div>
    }

  </div>
</div>
